import { type ModalOpenResult, useModalStore } from '@tix/modal'

export const EDIT_STEP_MODAL_NAME = 'flow-edit-step'

const DEFAULT_MESSAGE =
  "Editing this step will forget selections you've made after this point. You'll be guided to make new selections."

export type OpenEditStepModalProps = {
  onConfirm?: () => void
  title?: string
  continueLabel?: string
  cancelLabel?: string
  message?: string
}

export function openEditStepModal({
  onConfirm,
  title = 'Edit Step',
  continueLabel = 'Continue to Edit',
  cancelLabel = 'Cancel',
  message = DEFAULT_MESSAGE,
}: OpenEditStepModalProps = {}): ModalOpenResult {
  const modal = useModalStore()

  return modal.open({
    component: () => message,
    name: EDIT_STEP_MODAL_NAME,
    title,
    size: 'md',
    dismissible: true,
    closeable: true,
    actions: [
      {
        label: cancelLabel,
        hierarchy: 'secondary',
        intent: 'neutral',
        onAction: (close) => close(),
      },
      {
        label: continueLabel,
        hierarchy: 'primary',
        intent: 'confirm',
        onAction: (close) => {
          close()
          onConfirm?.()
        },
      },
    ],
  })
}
